import { IListResponse, XHRInstance } from "@sembark-travel/xhr"
import { IPaymentPreference } from "../store"
import { ServiceType } from "../../Supplier"

export function transportPaymentPreferencesXHR(xhr: XHRInstance) {
	return {
		async getTransportPaymentPreferences(
			params?: Record<string, string | number | undefined>
		): Promise<IListResponse<IPaymentPreference>> {
			return xhr
				.get("/supplier-payment-preferences", {
					params: {
						...params,
						service_type: ServiceType.TransportBookingServices,
					},
				})
				.then((resp) => resp.data)
		},
		async getTransportPaymentReferences(
			params?: Record<string, string | number | undefined>
		): Promise<IListResponse<{ id: number; name: string }>> {
			return xhr
				.get("/supplier-payment-preferences/references", {
					params: {
						...params,
						service_type: ServiceType.TransportBookingServices,
					},
				})
				.then((resp) => resp.data)
		},
	}
}
